module.exports = __webpack_public_path__ + "img/burrata_bites.dd96d1b7.jpg";